import React from 'react';
import { Button } from './ui/button';

const CTASection = () => {
  return (
    <section className="py-12 md:py-20 bg-gradient-to-br from-brand-50 via-white to-brand-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
          {/* Content */}
          <div className="space-y-6 text-center lg:text-left lg:flex-1">
            <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-gray-900 leading-tight">
              Get personalised skincare in minutes. Download decimal!
            </h2>
            <p className="text-base md:text-lg text-gray-600">
              Thousands already trust us for personalised skincare shopping.
            </p>

            {/* App Store Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start items-center">
              <a
                href="https://play.google.com/store/apps/details?id=com.decimalskincare&pcampaignid=web_share"
                className="inline-block transform hover:scale-105 transition-transform duration-200"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                  alt="Get it on Google Play"
                  className="h-12 md:h-14"
                />
              </a>
              <a
                href="https://apps.apple.com/in/app/decimal-beauty-shopping/id6748130980"
                className="inline-block transform hover:scale-105 transition-transform duration-200"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
                  alt="Download on App Store"
                  className="h-12 md:h-14"
                />
              </a>
            </div>
          </div>

          {/* Image */}
          <div className="flex justify-center lg:flex-1">
            <img
              src="https://customer-assets.emergentagent.com/job_beauty-dash-15/artifacts/5ynbeip0_Gemini_Generated_Image_jplbzcjplbzcjplb.png"
              alt="Decimal skincare products"
              className="w-full max-w-xs sm:max-w-sm md:max-w-md rounded-2xl shadow-2xl transform hover:scale-105 transition-transform duration-300"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;